import { render, staticRenderFns } from "./VendorEdit.vue?vue&type=template&id=3904fe0c&"
import script from "./VendorEdit.vue?vue&type=script&lang=js&"
export * from "./VendorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports